module.exports = __webpack_public_path__ + "img/chi-siamo-img-1.ce0f21ff.jpg";